// move an item in a list from it's original position (startIndex) to a destination position (endIndex)
export const reorderList = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

//Moves an elementFromOneListToAnother
export const moveElementToOtherList = (
  sourceList,
  sourceListId,
  destinationList,
  destinationListId,
  sourceElement,
  sourceElementIndex,
  destinationElement,
  destinationElementIndex,
) => {
  const sourceListClone = Array.from(sourceList);
  const destListClone = Array.from(destinationList);
  const [removed] = sourceListClone.splice(sourceElementIndex, 1);

  destListClone.splice(destinationElementIndex, 0, removed);

  const result = {};
  result[sourceListId] = sourceListClone;
  result[destinationListId] = destListClone;

  return result;
};
